import type { Action } from '../../domain/action'
import { actionStatsLabel, rewardRateLabel } from '../../domain/action'
import { CheckCircleIcon, MoreIcon, TimerIcon, CounterIcon, TrophyIcon } from './Icons'
import { useI18n } from '../../i18n'

interface ActionCardProps {
  action: Action
  color: string
  active: boolean
  highlighted?: boolean
  specializationLabel: string
  onOpen: (action: Action) => void
  onEdit: (action: Action) => void
}

const TypeIcon = ({ type }: { type: Action['type'] }) => {
  if (type === 'timer') return <TimerIcon />
  if (type === 'counter') return <CounterIcon />
  return <CheckCircleIcon />
}

export const ActionCard = ({ action, color, active, highlighted = false, specializationLabel, onOpen, onEdit }: ActionCardProps) => {
  const { language, copy: { action: actionCopy } } = useI18n()
  return <article className={`action-card${active ? ' action-card--active' : ''}${highlighted ? ' action-card--highlighted' : ''}`} style={{ '--action-color': color } as React.CSSProperties}>
    <button className="action-card__main" type="button" onClick={() => onOpen(action)} aria-label={`${actionCopy.open} ${action.name}`}>
      <span className="action-card__icon"><TypeIcon type={action.type} /></span>
      <span className="action-card__content">
        {active && <span className="action-card__active-label">{actionCopy.active}</span>}
        <strong>{action.name}</strong>
        {specializationLabel && <span className="action-card__categories">{specializationLabel}</span>}
        {action.repeatMode === 'once' && <span className="action-card__unique"><TrophyIcon /> {actionCopy.once}</span>}
        <span className="action-card__stats">{actionStatsLabel(action, language)}</span>
        <span className="action-card__reward">{rewardRateLabel(action)}</span>
      </span>
    </button>
    <button className="icon-button action-card__menu" type="button" onClick={() => onEdit(action)} aria-label={`${actionCopy.edit} ${action.name}`}><MoreIcon /></button>
  </article>
}
